module.exports = __webpack_public_path__ + "img/loginBollitsOrange.09419028.png";